/**
 * Drives the .reveal-group / .is-visible entrance-animation classes defined
 * in critical.css. Each direct child of a .reveal-group fades/slides in the
 * first time its group scrolls into view, then is left alone (no re-trigger
 * on scroll back out) so revisiting the section doesn't replay the animation.
 *
 * Exposes window.GasReveal.observe(group) so content injected after page
 * load (e.g. the "Completa tu look" recommendations fetched in
 * sections/product.liquid) can opt its own .reveal-group into the same
 * behavior once it exists in the DOM.
 */
window.GasReveal = (function () {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const supportsObserver = 'IntersectionObserver' in window;

  function revealAll(group) {
    Array.prototype.forEach.call(group.children, (child) => {
      child.classList.add('is-visible');
    });
  }

  const observer =
    supportsObserver && !prefersReducedMotion
      ? new IntersectionObserver(
          (entries, obs) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              revealAll(entry.target);
              obs.unobserve(entry.target);
            });
          },
          { threshold: 0, rootMargin: '0px 0px -10% 0px' },
        )
      : null;

  function observe(group) {
    if (!group) return;
    if (!observer) {
      revealAll(group);
      return;
    }
    observer.observe(group);
  }

  document.querySelectorAll('.reveal-group').forEach(observe);

  // The theme editor re-renders a section's markup over AJAX (not a full
  // page load) whenever a merchant tweaks a setting, so any `.reveal-group`
  // inside it is brand new to the DOM and was never handed to the observer
  // above — it's stuck at the CSS's initial opacity: 0 until a real page
  // load re-runs this whole script. Re-observing on `shopify:section:load`
  // is what makes the preview show the section without needing a save.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root) return;
    if (root.classList && root.classList.contains('reveal-group')) observe(root);
    root.querySelectorAll('.reveal-group').forEach(observe);
  });

  return { observe };
})();
